import { AttachmentResourceType } from '@/types'
import { Query as ShowQuery } from './show_query'
import { Collection as AttachmentsCollection } from '@/components/attachment/collection'

interface Props {
  id: string
}

export const EditImages = ({ id }: Props) => {
  return (
    <AttachmentsCollection
      filters={{ nameEq: 'images', resourceIdEq: id, resourceTypeEq: AttachmentResourceType.Package }}
      pageSize={10}
      refetchQueries={[ShowQuery]}
      title="Images"
      createable
      deleteable
      fixedHeight
    />
  )
}
